import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Dropdown,
  ButtonGroup,
  Tooltip,
  OverlayTrigger,
  Badge,
} from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import SourceHandler from "./SourceHandler";
import { updateUserWidget } from "~/pages/User/actions";

import widgetplaceholder from "~/assets/img/widgets/widget-placeholder.jpg";
import powerBiError from "~/assets/img/widgets/NoAccess_PowerBI.png";
import "~/assets/css/icons.css";
import "~/assets/css/styles.css";

const ServicoGenericoWidget = ({ apagarWidget, widget, index, ...props }) => {
  const { t } = props;
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.globalReducer);
  let itemsToshow = [];

  const isConfigAllowed = (config) => {
    if (user.username === "admin") return true;
    if (user.roles.some((role) => role.label === "ADMIN")) return true;
    if (
      config.roles === undefined ||
      config.roles === null ||
      config.roles.length === 0
    )
      return true;
    else {
      let isAllowed = false;
      config.roles.forEach((configRoleId) => {
        if (user && user.roles && user.roles.some((r) => r.id === configRoleId))
          isAllowed = true;
      });
      return isAllowed;
    }
  };

  if (user && user.roles) {
    const allConfigurations = widget.widget.configurations
      ? widget.widget.configurations
      : [];
    const configurationsByApp = allConfigurations.filter((item) =>
      item.apps.some((app) => app.pathname === path)
    );
    configurationsByApp.forEach((config) => {
      if (isConfigAllowed(config)) itemsToshow.push(config);
    });
  }

  const [source, setSource] = useState(undefined);
  const [isConfigNeeded, setIsConfigNeeded] = useState(true);
  const [isConfiguring, setIsConfiguring] = useState(false);

  const [errorMessage, setErrorMessage] = useState([]);

  useEffect(() => {
    setSource(undefined); //clean state
    setErrorMessage([]); //clean state
    if (widget.userConfiguration && widget.userConfiguration.configurationId) {
      const configId = widget.userConfiguration.configurationId;
      const source_ = widget.widget.configurations.find(
        (item) => item.id === configId
      );
      if (isConfigAllowed(source_)) {
        setSource(source_);
        setIsConfiguring(false); //clean state
        setIsConfigNeeded(false);
      } else setIsConfigNeeded(true);
    } else setIsConfigNeeded(true);
  }, [widget]);

  const configurar = () => {
    setIsConfiguring(true);
  };

  const cancel = () => {
    setIsConfiguring(false);
    if (widget.userConfiguration && widget.userConfiguration.configurationId) {
      const configId = widget.userConfiguration.configurationId;
      const source_ = widget.widget.configurations.find(
        (item) => item.id === configId
      );
      setSource(source_);
      setIsConfigNeeded(false);
    } else {
      setIsConfigNeeded(true);
      setSource(undefined);
    }
  };

  const save = () => {
    const payload = {
      id: widget.id,
      widgetId: widget.widgetId,
      userConfiguration: {
        type: ".PowerBIUserConfiguration",
        configurationId: source ? source.id : null,
      },
    };
    dispatch(updateUserWidget(payload));
    setIsConfiguring(false);
    source ? setIsConfigNeeded(false) : setIsConfigNeeded(true);
  };

  const ListForm = () => {
    const { SearchBar } = Search;
    const buildApplicationColumn = (_, row, index) => {
      return row.apps.map((app, index) => {
        return (
          <Badge
            pill
            key={index}
            variant="info"
            className="pointer lg-badge mr-2"
          >
            {app.description}
          </Badge>
        );
      });
    };
    const columns = [
      {
        dataField: "name",
        text: t("ServicoGenericoWidget.sourceName"),
        sort: true,
      },
      {
        dataField: "apps",
        sort: true,
        text: t("ServicoGenericoWidget.application"),
        formatter: buildApplicationColumn,
      },
    ];
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        setSource(row);
      },
    };

    return (
      <div style={{ overflowY: "scroll", height: "100%", padding: "10px" }}>
        {source ? (
          <span style={{ color: "#1f841f" }}>
            {t("ServicoGenericoWidget.selectedSource")}: &nbsp;
            <strong>{source.name}</strong>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="favoritos_tooltip">
                  {t("ServicoGenericoWidget.removeSource")}
                </Tooltip>
              }
            >
              <i
                className="icon-trash table-action-icon ml-5"
                onClick={() => {
                  setSource(undefined);
                }}
              ></i>
            </OverlayTrigger>
          </span>
        ) : (
          <span style={{ color: "#ca1717" }}>
            {t("ServicoGenericoWidget.noSourceSelected")}
          </span>
        )}
        <hr />
        <ToolkitProvider
          keyField="name"
          data={itemsToshow}
          columns={columns}
          search={{
            defaultSearch: source ? source.name : "",
          }}
        >
          {(props) => (
            <div style={{ width: "97%" }}>
              <SearchBar
                {...props.searchProps}
                placeholder={t("ServicoGenericoWidget.search")}
              />
              <hr />
              <BootstrapTable
                {...props.baseProps}
                bootstrap4
                pagination={paginationFactory()}
                noDataIndication={t("ServicoGenericoWidget.sourceNotFound")}
                striped
                hover
                rowEvents={rowEvents}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    );
  };

  return (
    <div className="main-card-v2" id="powerBI">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" />
            {/*widget.id*/}
            {isConfiguring
              ? t("ServicoGenericoWidget.configuration")
              : source
              ? source.name
              : t("ServicoGenericoWidget.title")}
          </h6>
          <Dropdown as={ButtonGroup} alignRight>
            <Dropdown.Toggle as={Dropdown.Header} variant="link">
              <i className="icon-gear" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu">
              <Dropdown.Item onClick={apagarWidget}>
                {t("widgets.remove")}
              </Dropdown.Item>
              <Dropdown.Item onClick={configurar}>
                {t("widgets.configure")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Card.Header>
        <Card.Body style={{ padding: "10px" }}>
          {isConfiguring ? (
            <ListForm />
          ) : isConfigNeeded ? (
            <div
              onClick={configurar}
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <h3>{t("widgets.configure")}</h3>
              <img
                style={{
                  borderRadius: "3%",
                  width: "300px",
                  height: "auto",
                  float: "left",
                }}
                src={widgetplaceholder}
                alt="Widget"
              />
            </div>
          ) : (
            <>
              {errorMessage.length !== 0 ? (
                <div
                  id={`reportContainerError${widget.id}`}
                  className="reportContainer"
                >
                  {errorMessage.some((e) => e === "401") ? (
                    <img src={powerBiError} alt="powerbi-error" />
                  ) : (
                    errorMessage
                  )}
                </div>
              ) : (
                <SourceHandler
                  widget={widget}
                  setErrorMessage={setErrorMessage}
                />
              )}
            </>
          )}
        </Card.Body>
        {isConfiguring ? (
          <Card.Footer>
            <Button variant="danger" onClick={cancel}>
              {t("general.cancel")}
            </Button>

            <Button
              className="card-button"
              style={{ marginLeft: "10px" }}
              onClick={save}
            >
              {t("ServicoGenericoWidget.save")}
            </Button>
          </Card.Footer>
        ) : null}
      </Card>
    </div>
  );
};
export default withNamespaces()(ServicoGenericoWidget);
